import React from 'react';
import PropTypes from 'prop-types';
import { restructureHours } from '../../../utilities/branches';
import { useShowroomUrls } from '../../../../hooks/use-showroom-urls';
import { isValidArray } from '../../../utilities/validations';

const BranchHomepageSD = ({ branchData, description, url, showrooms }) => {
	const { newShowrooms } = useShowroomUrls();

	const createHasPart = (showroomsArray) => {
		if (!isValidArray(showroomsArray)) return [];

		return showroomsArray.map((showroom, index) => ({
			'@type': 'ListItem',
			'position': `${index + 1}`,
			'item': {
				'@type': 'LocalBusiness',
				'name': showroom.name,
				'address': {
					'@type': 'PostalAddress',
					'streetAddress': showroom.line_1,
					'addressLocality': showroom.city,
					'addressRegion': showroom.state,
					'postalCode': showroom.postal_code,
					'addressCountry': showroom.country,
				},
				'telephone': showroom.phone,
				'geo': {
					'@type': 'GeoCoordinates',
					'latitude': `${showroom.location?.coordinates?.[1]}`,
					'longitude': `${showroom.location?.coordinates?.[0]}`,
				},
				'url': `${process.env.GATSBY_SITE_URL}${newShowrooms?.nodes?.find((showroom) => showroom.showroom_id === showroom.store_number)?.url}`,
				'openingHoursSpecification': restructureHours(showroom),
			},
		}));
	};

	return (
		<script
			type='application/ld+json'
			dangerouslySetInnerHTML={{
				__html: `
                {
                    "@context": "http://schema.org",
                    "@type": "ItemList",
                    "name": "${branchData?.formal_name}",
                    "description": "${description || ''}",
                    "url": "${process.env.GATSBY_SITE_URL + url}",
                    "itemListElement": [${createHasPart(showrooms)
						.map((showroom) => JSON.stringify(showroom))
						.join(',')}]
                }
            `,
			}}
		/>
	);
};

BranchHomepageSD.propTypes = {
	branchData: PropTypes.object,
	description: PropTypes.string,
	url: PropTypes.string,
	showrooms: PropTypes.array,
};

export default BranchHomepageSD;
